import styled from "styled-components";
export const CalHeader = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
`;
export const MonthYearHeader = styled.div `
display: flex;
column-gap: 15px;
`;
